import React, { FC, HTMLAttributes } from "react";

export type ContentProps = HTMLAttributes<HTMLParagraphElement> & {
  contentType?: "date";
  dateModified?: Date | string;
};

const isValidDate = (date: Date): boolean => {
  return date instanceof Date && !Number.isNaN(date.getTime());
};

const formatDate = (date: Date): string => {
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const Content: FC<ContentProps> = ({
  children,
  contentType,
  dateModified,
  ...rest
}) => {
  let formattedDate: string | undefined;
  if (dateModified) {
    if (dateModified instanceof Date) {
      formattedDate = isValidDate(dateModified)
        ? formatDate(dateModified)
        : undefined;
    } else if (typeof dateModified === "string") {
      const parsedDate = new Date(dateModified);
      formattedDate = isValidDate(parsedDate)
        ? formatDate(parsedDate)
        : undefined;
    }
  }

  return contentType === "date" ? (
    <p {...rest}>{formattedDate}</p>
  ) : (
    <p {...rest}>{children}</p>
  );
};

export default Content;
